import { lazy } from "react";
import App from "../App";
import IRoute from "../routes/IRoute";
import authRoutes from "../routes/auth.routes";
import matchesRoutes from "./matches.routes";
import blogRoutes from "../routes/blog.routes";
import feedRoutes from "../routes/feed.routes";
import standingRoutes from "../routes/standings.routes";
import usersRoutes from "./users.routes";
import adminRoutes from "./admin.routes";
import bookmakersRoute from "./bookmakers.routes";
import learnRoutes from "./learn.routes";

// Profile + error pages share the lazy treatment with every other
// route. App stays eagerly imported — it's the auth-bootstrap shell
// that renders before any route resolves and is needed synchronously.
const MyProfilePage = lazy(() => import("../pages/Users/MyProfilePage"));
const ForbiddenPage = lazy(() => import("../pages/Error/ForbiddenPage"));
const PageNotFound = lazy(() => import("../pages/Error/NotFoundPage"));

const routes: Array<IRoute> = [
  {
    path: "/",
    component: App,
  },
  adminRoutes,
  authRoutes,
  {
    path: "/profile",
    component: MyProfilePage,
    needAuth: true,
  },
  feedRoutes,
  matchesRoutes,
  blogRoutes,
  standingRoutes,
  bookmakersRoute,
  usersRoutes,
  learnRoutes,
  {
    path: "/forbidden",
    component: ForbiddenPage,
  },
  {
    path: "*",
    component: PageNotFound,
  },
];

export default routes;
